import React from "react";
import { CRow, CCol, CContainer, CImg } from "@coreui/react";
import { TheHeaderGuest } from "src/containers";
import { ILHero } from "src/assets";

const Home = () => {
  return (
    <>
      <TheHeaderGuest />
      <div className="bg-primary vh-100">
        <CContainer fluid={false}>
          <CRow>
            <CCol
              md="7"
              className="d-flex align-items-center justify-content-center pt-5"
            >
              <div>
                <h1 className="text-white font-weight-bold mb-3">
                  Surveyor Berlisensi
                </h1>
                <h5 className="text-white text-md mb-3">
                  SURLIS Mitra Kementerian ATR/BPN menyediakan layanan survei
                  pengukuran dan pemetaan yang berfungsi untuk berbagai
                  keperluan.
                  <br />
                  <br />
                  Layanan ini mencakup pengukuran luas tanah untuk keperluan
                  jual beli, pembagian waris, dan pembebasan lahan, serta
                  pendaftaran pertama kali, pemecahan, pemisahan, penggabungan,
                  pengukuran ulang, pengembalian batas, pembaharuan hak,
                  pemberian hak, pengukuran topografi/kontur, pemotretan
                  drone/UAV, lidar, penentuan batas kawasan, penilaian tutupan
                  lahan, plotting, staking-out, pemetaan 3D kadastral, pembuatan
                  peta tematik, serta penerbitan sertifikat layak fungsi (SLF),
                  dan masih banyak lagi.
                </h5>
                <a
                  target="_blank"
                  href="https://play.google.com/store/apps/details?id=com.maski.survei&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1"
                  rel="noreferrer"
                >
                  <img
                    alt="Temukan di Google Play"
                    src="https://play.google.com/intl/en_us/badges/static/images/badges/id_badge_web_generic.png"
                    width={180}
                    height="auto"
                  />
                </a>
              </div>
            </CCol>
            <CCol
              md="5"
              className="d-none d-lg-flex align-items-center justify-content-center  "
            >
              <CImg
                src={ILHero}
                width="auto"
                height="300"
                className="rounded mx-2"
              />
            </CCol>
            <CCol md="12" className="d-none d-lg-flex ">
              <div className="d-flex mt-5">
                <CImg
                  src={"/assets/images/unnamed.png"}
                  width="auto"
                  height="300"
                  className="rounded mx-2"
                />
                <CImg
                  src={"/assets/images/unnamed-2.png"}
                  width="auto"
                  height="300"
                  className="rounded mx-2"
                />
                <CImg
                  src={"/assets/images/unnamed-3.png"}
                  width="auto"
                  height="300"
                  className="rounded mx-2"
                />
                <CImg
                  src={"/assets/images/unnamed-4.png"}
                  width="auto"
                  height="300"
                  className="rounded mx-2"
                />
                <CImg
                  src={"/assets/images/unnamed-5.png"}
                  width="auto"
                  height="300"
                  className="rounded mx-2"
                />
                <CImg
                  src={"/assets/images/unnamed-6.png"}
                  width="auto"
                  height="300"
                  className="rounded mx-2"
                />
                <CImg
                  src={"/assets/images/unnamed-7.png"}
                  width="auto"
                  height="300"
                  className="rounded mx-2"
                />
              </div>
            </CCol>
          </CRow>
        </CContainer>
      </div>

      {/* <div style={{ backgroundColor: "#E5F3FE" }}>
        <CContainer fluid={false} className="py-3">
          <CRow className="d-flex justify-content-center align-items-center">
            <div className="">
              <CCarousel activeIndex={1} sl>
                <CCarouselIndicators />
                <CCarouselInner>
                  <CCarouselItem>
                    <CImg
                      src={
                        "https://api.member.maski.or.id/Assets/User/K-202201-09548_3.png?1693227179790"
                      }
                      width="100"
                      height="100"
                      className="rounded mx-2"
                    />
                    <CCarouselCaption>
                      <h3>Slide 1</h3>
                      <p>Slide 1</p>
                    </CCarouselCaption>
                  </CCarouselItem>
                  <CCarouselItem>
                    <CImg
                      src={
                        "https://api.member.maski.or.id/Assets/User/K-202201-09548_3.png?1693227179790"
                      }
                      width="100"
                      height="100"
                      className="rounded mx-2"
                    />
                    <CCarouselCaption>
                      <h3>Slide21</h3>
                      <p>Slide 12</p>
                    </CCarouselCaption>
                  </CCarouselItem>
                </CCarouselInner>
              </CCarousel>
            
            </div>
          </CRow>
        </CContainer>
      </div> */}
    </>
  );
};

export default Home;
